import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import setting from './modules/setting'

Vue.use(Vuex)

const state = {
}
const mutations = {

}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    account,
    setting
  }
})
